import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import React from 'react'
import { useEditBusinessTripForm } from '../../../../context/EditBusinessTripFormContext'
import { TextAreaField } from '@/ui/form/controls/TextAreaField'

const DestinationStage = () => {
  const { data, setData} =
    useEditBusinessTripForm()
  return (
    <div className="tw-flex tw-items-start tw-justify-between">
      <div className="tw-jusit tw-flex tw-flex-[1] tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
        <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
        <p className="tw-text-sm tw-font-semibold tw-text-content-base">
          Cel delegacji
        </p>
      </div>

      <div className="tw-flex tw-flex-[2] tw-flex-col tw-gap-2">
        <TextAreaField
          value={data?.purpose}
          onChange={(e) => setData({ ...data, purpose: e.target.value })}
          maxLength={382}
          placeholder="Wpisz cel delegacji..."
          fullWidth
          rows={4}
        />
      </div>
    </div>
  )
}

export default DestinationStage
